import { render, staticRenderFns } from "./GiteaPublishModal.vue?vue&type=template&id=01de9dc4&"
import script from "./GiteaPublishModal.vue?vue&type=script&lang=js&"
export * from "./GiteaPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteaPublishModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteaPublishModal.vue
// module id = 2353
// module chunks = 1